import clsx from 'clsx';

export default function Loader({ variant = 'lg' }: { variant?: 'sm' | 'lg' | 'xl' }) {
  const sizes = variant == 'sm' ? 'h-8 w-8' : 'h-16 w-16';
  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <div className={clsx(sizes, 'rounded-full border-t-8 border-b-8 border-y-primary-50')} />
        <div
          className={clsx(
            sizes,
            'absolute top-0 left-0 h-${s} w-${s} rounded-full border-t-8 border-b-8 border-primary-300 animate-spin'
          )}
        />
      </div>
    </div>
  );
}
